import React from 'react';
import PropTypes from 'prop-types';

const CheckCircle = props => {
  const { color, width, height, ...other } = props;

  return (
    <svg width={width} height={height} viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" {...other}>
      <g id="check--circle" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <polygon id="Shape" points="0 0 24 0 24 24 0 24"></polygon>
        <path d="M12,22 C17.5228475,22 22,17.5228475 22,12 C22,6.4771525 17.5228475,2 12,2 C6.4771525,2 2,6.4771525 2,12 C2,17.5228475 6.4771525,22 12,22 Z M9.54105254,17.7811532 C9.38354635,17.5611533 6.28128816,12.0983791 6.05124277,11.7303064 C5.82119738,11.3622338 6.42131938,10.8684018 6.74920473,11.0323445 C7.07709008,11.1962872 9.23534234,13.4615529 9.54105254,13.6850174 C9.84676273,13.9084819 10.1974634,13.8460377 10.3781894,13.6850174 C10.5589154,13.5239971 16.8855995,6.44881052 17.218634,6.14661082 C17.5516685,5.84441113 18.2375972,6.32984897 17.916596,6.84457278 C17.5955948,7.35929658 10.4371559,17.7043954 10.3832713,17.7811532 C10.2279529,18.0024015 9.69855872,18.0011531 9.54105254,17.7811532 Z" id="Combined-Shape" fill={color}></path>
      </g>
    </svg>
  );
}

CheckCircle.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

CheckCircle.defaultProps = {
  color: '#000000',
  width: 24,
  height: 24,
};

export default CheckCircle;



// WEBPACK FOOTER //
// ./src/components/Icons/CheckCircle.jsx